import { Empty, Image, Modal } from 'antd';
import PrivateReceiptImage from 'components/private-receipt-image';
import LOCALS from 'commons/locals';
import i18n from 'i18n';

type ReceiptImagesManageModalProps = {
  open: boolean;
  receiptKeys: string[];
  onClose: () => void;
  onChange: (keys: string[]) => void;
  title?: string;
  footer?: React.ReactNode;
  extra?: React.ReactNode;
};

export const ReceiptImagesManageModal = ({
  open,
  receiptKeys,
  onClose,
  onChange,
  title,
  footer = null,
  extra,
}: ReceiptImagesManageModalProps) => {
  const modalTitle =
    title ??
    (receiptKeys.length
      ? i18n.t(LOCALS.payment_receipt_images_title_count, {
          count: receiptKeys.length,
        })
      : i18n.t(LOCALS.payment_receipt_images));

  return (
    <Modal
      open={open}
      title={modalTitle}
      onCancel={onClose}
      footer={footer}
      destroyOnClose
      width={640}
    >
      {receiptKeys.length === 0 ? (
        <Empty description={i18n.t(LOCALS.payment_receipt_images_empty)} />
      ) : (
        <Image.PreviewGroup>
          <div className="flex flex-wrap gap-4">
            {receiptKeys.map((imageKey) => (
              <PrivateReceiptImage
                key={imageKey}
                imageKey={imageKey}
                width={120}
                onRemove={() =>
                  onChange(receiptKeys.filter((key) => key !== imageKey))
                }
              />
            ))}
          </div>
        </Image.PreviewGroup>
      )}

      {extra ? <div className="mt-4">{extra}</div> : null}
    </Modal>
  );
};
